import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { HeaderComponent } from '../../shared/header.component';
import { CdkTableModule } from '@angular/cdk/table';
import { GroupsService } from '../groups.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UserDto } from '@oracychampions/api-interfaces';
import { ConfirmComponent } from '../../shared/confirm.modal';
import { AssignTeacherComponent } from './assign-teacher.component';
import { AuthService } from '../../auth/auth.service';
import { Observable } from 'rxjs';
import { CardComponent } from '../../shared/card.component';

@Component({
  selector: 'oc-teachers',
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, CdkTableModule, CardComponent],
  providers: [],
  template: ` <div class="container-fluid page">
    <oc-header headerTitle="Teachers">
      <button class="btn btn-primary btn-rounded" (click)="assignTeacher()">Assign Teacher</button>
    </oc-header>

    <div class="oc-teachers-grid">
      <oc-card
        *ngFor="let teacher of teachers$ | async"
        [mainTitle]="teacher.firstName + ' ' + teacher.lastName"
        icon="tablerUser"
        [actions]="actions(teacher)"
      ></oc-card>
    </div>
  </div>`,
  styles: `
    .oc-teachers-grid {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      grid-template-rows: repeat(auto, 1fr);
      gap: 1rem;
      justify-content: start;
    }
  `,
})
export class TeachersComponent {
  private groupsService = inject(GroupsService);
  private route = inject(ActivatedRoute);
  private modalService = inject(NgbModal);
  private toastr = inject(ToastrService);
  private auth = inject(AuthService);
  private groupId: string;

  public teachers$: Observable<UserDto[]>;

  displayedColumns = ['firstName', 'lastName', 'createDate', 'actions'];

  constructor() {
    this.groupId = this.route.parent?.snapshot.params['id'];
    this.teachers$ = this.groupsService.getTeachers(this.groupId);
  }

  actions(teacher: UserDto): any[] {
    return [
      {
        title: 'Remove',
        action: () => {
          return this.removeTeacher(teacher);
        },
      },
    ];
  }

  assignTeacher() {
    const modalRef = this.modalService.open(AssignTeacherComponent, { fullscreen: true });
    modalRef.componentInstance.groupId = this.groupId;
    modalRef.componentInstance.schoolId = (this.auth.auth$.getValue()?.user as UserDto).schoolId;
    modalRef.closed.subscribe(() => {
      this.groupsService.reloadTeachers();
    });
  }

  removeTeacher(teacher: UserDto) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.closed.subscribe((confirmed) => {
      if (confirmed) {
        this.groupsService.removeTeacher(this.groupId, teacher.id).subscribe(() => {
          this.toastr.success('Teacher deleted');
          this.groupsService.reloadTeachers();
        });
      }
    });
  }
}
